import styled from 'styled-components';
import { BodyRegularS, CaptionRegularM, LabelRegularM, DarkButton } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ISeachDropCont {
  width?: string;
}

export const SearchDropCont = styled.div<ISeachDropCont>`
  position: relative;
  ${({ width }: ISeachDropCont) => `
      width: ${width || '320px'};
  `};
`;

interface IArrowCont {
  theme: ITheme;
  active?: boolean;
}

export const ArrowCont = styled.div<IArrowCont>`
  position: absolute;
  cursor: pointer;
  svg {
    height: 12px;
    width: 12px;
  }
  transition: all 0.05s;
  transition-timing-function: cubic-bezier(0.1, 0.7, 1, 0.1);
  ${({ active }: IArrowCont) => `
        right: ${active ? '14px' : '18px'};
        transform:  ${active ? 'rotate(270deg)' : 'rotate(90deg)'}
        
    `};
`;

interface IDropDownBody {
  theme: ITheme;
  error?: boolean;
  isMulti?: boolean;
  width?: string;
  direction: 'small' | 'big';
}
export const DropDownBody = styled.div<IDropDownBody>`
  position: absolute;
  top: 48px;
  z-index: 100;
  border-radius: 0 0 8px 8px;
  overflow: auto;

  ${({ theme, error, width, isMulti, direction }: IDropDownBody) => `
    width: ${width || '320px'};
    max-height: ${isMulti ? 'auto' : direction === 'small' ? '150px' : '280px'};
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${
      error ? theme.colors.support.orange[100] : theme.colors.neutral.primary[10]
    };

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
      background: ${theme.colors.secondary[30]};
    }
  
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.secondary[70]};
      border-radius: 5px;
    }
  
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.secondary[100]};
    }
  `};
`;

export const DropDownStaticHead = styled(BodyRegularS)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

interface IDropBodyTileCont {
  theme: ITheme;
  active?: boolean;
  withDescription?: boolean;
}

export const DropBodyTileCont = styled(BodyRegularS)<IDropBodyTileCont>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  cursor: pointer;
  padding: 10px 12px;

  ${({ theme, active, withDescription }: IDropBodyTileCont) => `
    ${active ? `background: ${theme.colors.primary[10]};` : ''}
    ${withDescription ? `border-bottom: 1px solid ${theme.colors.neutral.primary[20]};` : ''}
    font-weight: ${withDescription ? '500' : 'initial'};

    &:hover {
      background: ${theme.colors.primary[10]};
    }
    `};
`;

export const Description = styled.div`
  font-size: 13px;
  line-height: 16px;
  padding-top: 3px;
  font-weight: 400;
  width: 100%;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const DropDownInput = styled.input`
  width: 100%;
`;

export const ErrorMsg = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.support.orange[100]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const InfoStaticIconCont = styled.div`
  position: absolute;
  bottom: -23px;
  left: -2px;
  svg {
    width: 13px;
    height: 13px;
  }
`;

export const InfoStaticMessage = styled(CaptionRegularM)`
  position: relative;
  top: -2px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[60]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const SaveButton = styled(DarkButton)`
  margin: 6px 12px 10px 12px;
  height: 36px;
  width: calc(100% - 24px);

  &:disabled {
    opacity: 0.5;
  }
`;

export const ErrorMsgCont = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 2px;
  svg {
    margin: 0 4px 0 0;
  }
`;

export const Label = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[100]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const FormFieldCont = styled.div`
  ${({ theme }: IThemeProvider) => `
      margin: 0 0 ${theme.layout.spacing.deka} 0;
  `}
`;

export const DropRelCont = styled.div`
  position: relative;
`;

export const DropCont = styled.div`
  position: relative;
`;

export const IconImg = styled.img`
  ${({ theme }: IThemeProvider) => `
      margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const CheckActiveCont = styled.div`
  position: absolute;
  ${({ theme }: IThemeProvider) => `
      right: ${theme.layout.spacing.decy};
  `}
`;

export const CustomInfoCont = styled.div`
  position: absolute;
  right: 0;
`;

export const AdditionalInfo = styled(BodyRegularS)`
  position: absolute;
  right: 50px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
